import {
  getGetBrandsBrandIdAccountUrl,
  getPostPublicAccountsTwitterHandleUrl,
  getPostPublicAccountsUrl,
} from '@dashhudson/api-client/twitter/client';
import merge from 'lodash/merge';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

const http = createDashHttpClient(env.twitterApiUrl);
const httpCamelCase = createDashHttpClient(env.twitterApiUrl, {
  camelizeKeys: true,
});

export const fetchUsers = (
  { handles, brandId }: { handles: string | string[]; brandId?: number },
  config: HttpRequestConfig = {},
) =>
  httpCamelCase.get(`/users`, {
    ...config,
    params: { handles, brandId },
  });

export async function getTwitterAccount(
  { brandId }: { brandId: number },
  config: HttpRequestConfig = {},
) {
  return http.get(getGetBrandsBrandIdAccountUrl(brandId), config);
}

export async function getTwitterAccounts(
  { brandIds }: { brandIds: number[] },
  config: HttpRequestConfig = {},
) {
  return http.get(
    `/brands/accounts`,
    merge(
      {
        params: {
          brandIds: brandIds.join(','),
        },
      },
      config,
    ),
  );
}

export async function refreshTwitterAdsAccount(
  { brandId }: { brandId: number },
  config: HttpRequestConfig = {},
) {
  return http.post(`/brands/${brandId}/account/refresh/ads_account`, {}, config);
}

export async function addAccount({ handle }: { handle: string }, config: HttpRequestConfig = {}) {
  return http.post(getPostPublicAccountsTwitterHandleUrl(handle), {}, config);
}

export async function getPublicAccountsByIds(
  { twitterUserIds }: { twitterUserIds: string[] },
  config: HttpRequestConfig = {},
) {
  return httpCamelCase.post(getPostPublicAccountsUrl(), { twitterUserIds }, config);
}
